import { createApp } from 'vue';
import OpusToM4aConverter from '@/Components/OpusToM4aConverter.vue';
import '@styles/app.css';

createApp(OpusToM4aConverter).mount('#opus-to-m4a-converter');
